const moment = require("moment-timezone");

/**
 * Format an Eloquent timestamp (created_at / updated_at) in King County time.
 *
 * Those columns are serialized to JSON as UTC ("2026-08-12T12:30:00.000000Z"), so
 * rendering them with plain moment() shows the VIEWER's timezone — an admin abroad saw
 * 5:30 PM for a job created at 5:30 AM Pacific. Converting explicitly means everyone
 * sees the court's local time.
 *
 * NOTE: only for UTC-serialized timestamps. Wall-clock columns (appointments.datetime,
 * date, start_time, appointment_logs.date/time) are already stored in Pacific and must
 * be formatted WITHOUT conversion — see helpers/convertDateFormat.
 *
 * The `z` token prints PDT or PST correctly rather than hardcoding one of them.
 */
export const formatServerDateTime = (value) => {
  if (!value) return "-";

  const parsed = moment.utc(value);
  if (!parsed.isValid()) return "-";

  return parsed.tz("America/Los_Angeles").format("MMM D, YYYY h:mm A z");
};

export default formatServerDateTime;
